import InfoIcon from '@material-ui/icons/Info';
import PropTypes from 'prop-types';
import React from 'react';

class Information extends React.Component {

    render() {

        const { text, dataTest, margin } = this.props;

        return (
            <div data-test={dataTest || "information-box"}
                style={{
                    border: 'solid 1px #01579B',
                    fontSize: 14,
                    borderRadius: '4px',
                    padding: '6px 6px 4px 6px',
                    color: '#01579B',
                    marginBottom: margin ? '12px' : '0px'
                }}>
                <InfoIcon style={{ verticalAlign: 'middle', transform: 'translateY(-1px)' }} />
                <span style={{ marginLeft: 6 }}>
                    {text}
                </span>
            </div >

        );
    }
}

Information.defaultProps = {
    margin: false
};

Information.propTypes = {
    margin: PropTypes.bool,
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
    ]).isRequired,
    dataTest: PropTypes.string
};

export default Information;